import { sbMsgBusInstance as sbMsgBus } from "../../mbus";
/* istanbul ignore file */
export var GeneralTopics = {
    SB_PlaceBetTopic: sbMsgBus.sbPrefix + "place_bet_topic",
    SB_CashoutTopic: sbMsgBus.sbPrefix + "cashout_topic"
};
//# sourceMappingURL=General.js.map